import styled from 'styled-components';
import { SlideOut } from '@interstate/components/SlideOut';

// Slideout container styles
export const SlideoutContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const GrowingSlideoutContainer = styled(SlideoutContainer)`
    flex: 1;
`;

export const StyledCreditAppSearchSlideOut = styled(SlideOut)`
    .MuiDrawer-paper {
        display: flex;
        flex-direction: column;
    }
    .ids-SlideOut-content {
        padding-bottom: 1.714rem;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
`;

// Search form styles
export const SearchFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
`;

export const SearchInputGroup = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1.5rem;
    row-gap: 1rem;
`;

export const SearchButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 2rem;
    gap: 1rem;
    justify-content: flex-end;
    margin-right: 1rem;
`;

export const SearchDescription = styled.p`
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
`;

// Results view styles
export const ResultsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
`;

export const ResultCard = styled.div`
    border: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
    border-radius: 4px;
    padding: 1.5rem;
    background: ${({ theme }) => theme.tokens.BaseColorWhite};
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const SelectableResultCard = styled(ResultCard)<{ $selected: boolean }>`
    gap: 0.5rem;
    border: ${({ theme, $selected }) =>
        $selected ? `2px solid ${theme.tokens.BaseColorBlue700}` : `1px solid ${theme.tokens.BaseColorGray300}`};
    background: ${({ theme, $selected }) => ($selected ? theme.tokens.BaseColorBlue50 : theme.tokens.BaseColorWhite)};
`;

export const ResultNameRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1;
    min-width: 0;
`;

export const CoAppBadge = styled.span`
    color: ${({ theme }) => theme.tokens.BaseColorBlue700};
    font-size: 0.875rem;
`;

export const ResultHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const CustomerInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 0.5rem;
`;

export const CustomerName = styled.h3`
    margin: 0;
`;

export const ResultContentGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    align-items: start;
`;

export const ContactInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    & > * {
        margin-bottom: 0.25rem;
    }

    & > *:last-child {
        margin-bottom: 0;
    }
`;

export const VehicleInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    & > * {
        margin-bottom: 0.25rem;
    }

    & > *:last-child {
        margin-bottom: 0;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding: 3rem;
`;

export const EmptyStateContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    background-color: ${({ theme }) => theme.tokens.BaseColorGray50};
`;

// Review view styles
export const ReviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    height: 100%;
`;

export const ReviewHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

// Will Attach To Section
export const WillAttachToSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding-bottom: 1rem;
    border-bottom: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
`;

export const AttachToGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-top: 0.5rem;

    @media (min-width: 768px) {
        grid-template-columns: repeat(4, 1fr);
    }
`;

export const AttachToColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    @media (min-width: 768px) {
        gap: 0.25rem;
    }
`;

export const AttachToColumnGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

// Mobile only: Shows on xs, hides on md+
export const MobileOnly = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    @media (min-width: 768px) {
        display: none;
    }
`;

// Desktop only: Hides on xs, shows on md+
export const DesktopOnly = styled.div`
    display: none;

    @media (min-width: 768px) {
        display: flex;
        flex-direction: column;
    }
`;

export const AttachToValue = styled.div``;

// Change Summary Section
export const ChangeSummarySection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 1;
    overflow-y: auto;
`;

export const ChangeSummaryColumns = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    align-items: stretch;

    @media (max-width: 599px) {
        grid-template-columns: 1fr;
    }
`;

export const ChangeSummaryColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: 100%;
`;

export const DataSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    border: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
    border-radius: 4px;
    padding: 1.5rem;
    background: ${({ theme }) => theme.tokens.BaseColorWhite};
`;

export const DataRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
`;

export const DataRowWithBadge = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1rem;
`;

export const DataContent = styled.div`
    flex: 1;
`;

export const DataGroup = styled.div`
    margin-bottom: 1rem;
`;

export const ChangeGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.75rem 0;
    border-bottom: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const FieldLine = styled.div`
    display: flex;
    flex-wrap: wrap;
    column-gap: 1.5rem;
`;

export const FieldLabel = styled.span`
    color: ${({ theme }) => theme.tokens.BaseColorGray600};
`;

export const NewDataSection = styled(DataSection)`
    border: ${({ theme }) => `2px solid ${theme.tokens.BaseColorGreen600}`};
    background: ${({ theme }) => theme.tokens.BaseColorGreen50};
`;
